import { handleClientNextAction } from "@/services/clientNextAction";

export default {
    async initPayment () {
        return null
    },
    async checkAvailability () {
        return { available: true }
    },
    async handlePayment ({
        config,
        doBindCardPayment,
        toast,
        hideLoading
    }) {
        try {
            const gatewayId = config?.oneclickGatewayId || 0
            const res = await doBindCardPayment({
                paymentMethod: 'oneclick',
                gatewayId
            })
            const result = await handleClientNextAction(res)
            if (!result.handled) {
                toast('Unexpected client_next_action')
            }
        } catch (err) {
            const i18n = (await import('@/main')).default?.i18n
            const fallback = i18n ? i18n.t('tMsg.bindFailed') : 'Bind card failed'
            const message = err?.message || fallback
            toast(message, { persistent: !!err?.message })
            try {
                const router = (await import('@/router')).default
                if (router.currentRoute?.name !== 'payment_select') {
                    router.push({ name: 'payment_select' })
                }
            } catch (_) {}
        } finally {
            hideLoading()
        }
    }
 }
